import React from "react";
import { FiMail } from "@react-icons/all-files/fi/FiMail";
import { FiPhone } from "@react-icons/all-files/fi/FiPhone";
import { colors } from "~/utils/colors";
import { breakPoints } from "~/utils/variables";
import { CONTACT_FALLBACK } from "~/constant/path";

/**
 * フォーム直下に表示する案内（プライバシーポリシー同意・送信不可時の連絡先）
 * すべてのHubSpot埋め込みフォーム下で使用
 * /request, /inquiry/contact, /partner-application, /meeting, 資料DL, セミナー申込・アーカイブ申込 など
 */
export const FormNotice: React.FC<{ className?: string }> = ({ className = "" }) => {
  return (
    <>
      <style jsx>{`
        .notice {
          margin-top: 24px;
          font-size: 14px;
          color: ${colors.defaultText};
          line-height: 1.6;
        }
        .privacy {
          margin-bottom: 16px;
        }
        .privacyLink {
          color: ${colors.darkBlue};
          text-decoration: underline;
        }
        .privacyLink:hover {
          text-decoration: none;
        }
        .fallbackIntro {
          margin-bottom: 16px;
        }
        .contactRow {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          gap: 16px 24px;
        }
        .contactItem {
          display: inline-flex;
          align-items: center;
          gap: 6px;
        }
        .contactItem a {
          color: ${colors.defaultText};
        }
        .contactItem:hover a,
        .contactItem a:hover {
          color: ${colors.brand};
        }
        .contactItem:hover .contactIconWrap {
          color: ${colors.brand};
        }
        .contactIconWrap {
          display: inline-flex;
          flex-shrink: 0;
          color: ${colors.defaultText};
        }
        .contactIconWrap :global(svg) {
          color: inherit;
          stroke: currentColor;
        }
        .telHours {
          font-size: 12px;
          color: ${colors.littleBrightGray};
        }
        @media (${breakPoints.sp}) {
          .notice {
            margin-top: 20px;
            font-size: 13px;
          }
        }
      `}</style>
      <div className={`notice ${className}`.trim()}>
        <p className="fallbackIntro">※フォームが表示・送信されない場合は、以下へお問い合わせください。</p>
        <div className="contactRow">
          <span className="contactItem">
            <span className="contactIconWrap">
              <FiMail style={{ fontSize: "16px" }} aria-hidden />
            </span>
            <a href={`mailto:${CONTACT_FALLBACK.email}`}>{CONTACT_FALLBACK.email}</a>
          </span>
          <span className="contactItem">
            <span className="contactIconWrap">
              <FiPhone style={{ fontSize: "16px" }} aria-hidden />
            </span>
            <a href={`tel:${CONTACT_FALLBACK.tel.replace(/-/g, "")}`}>{CONTACT_FALLBACK.tel}</a>
            <span className="telHours">（{CONTACT_FALLBACK.telHours}）</span>
          </span>
        </div>
      </div>
    </>
  );
};
